import { fadeInDown } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../../assets/styles/colors";

const fadeInDownAnimation = keyframes`${fadeInDown}`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const HeaderContainer = styled.div`
  width: ${(props) => (props?.isDesktop ? "550px" : "100%")};
  border-bottom: 1px solid
    ${(props) =>
      props.theme.isDarkTheme ? Color.textColorBlackFor : Color.colorWhite};
  height: 100px;
  z-index: 9;
  position: fixed;
  background-color: ${(props) =>
    props.theme.isDarkTheme ? Color.colorDarkOne : Color.colorWhite};
  position: fixed;
  animation: 1s ${fadeInDownAnimation};

  ${(props) =>
    props?.isDesktop
      ? `box-shadow: 0 0 3px 1px ${
          props.theme.isDarkTheme ? "#1c1c1c" : Color.textColorBlackSeven
        };`
      : `box-shadow: 0 0 6px 2px ${
          props.theme.isDarkTheme
            ? Color.colorDarkOne
            : Color.textColorBlackSeven
        };`}
`;

export const HeaderItem = styled.div`
  transform: translate3d(0px, 0px, 0px);
  direction: rtl;
  height: 100px;
  max-width: 100%;
  white-space: nowrap;
  overflow: auto hidden;
  transition: all 0s ease 0s;
`;

export const HeaderImg = styled.img`
  width: 40px;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
  background-size: 40px 40px;
  margin-bottom: 10px;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1) 0s;
`;

export const HeaderTitle = styled.strong`
  display: block;
  font-weight: 400;
  font-size: 13px;
  width: 100%;
  overflow: hidden;
  whitespace: nowrap;
  text-overflow: ellipsis;
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.colorWhite : Color.textColorBlackFor};
`;

export const LoadingContainer = styled.div`
  display: ${(props) => (props.isLoading ? "block" : "none")};
`;

export const LoadingHeaderImg = styled.div`
  width: 40px;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
  background-size: 40px 40px;
  margin-bottom: 10px;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1) 0s;
`;

export const LoadingItem = styled.div``;
